(function () {
  let blockAutoScrollUntil = 0;

  // Keep originals
  const _scrollTo = window.scrollTo.bind(window);
  const _scrollIntoView = Element.prototype.scrollIntoView;
  const _focus = HTMLElement.prototype.focus;

  // Helper: should we block right now?
  function blocking() {
    return Date.now() < blockAutoScrollUntil;
  }

  // Helper: detect a "product media" target (where themes usually scroll)
  function isProductMediaTarget(el) {
    if (!el || !el.closest) return false;

    // Common Dawn / Shopify selectors for product gallery/media
    return Boolean(
      el.closest(".product__media") ||
      el.closest(".product__media-wrapper") ||
      el.closest(".product__media-list") ||
      el.closest("media-gallery") ||
      el.closest("product-media") ||
      el.closest("product-gallery") ||
      el.closest(".product-media") ||
      el.closest("[data-media-id]") ||
      el.closest("[id^='MediaGallery-']") ||
      el.closest("[id^='ProductMedia-']")
    );
  }

  // Override scrollIntoView
  Element.prototype.scrollIntoView = function () {
    if (blocking() && isProductMediaTarget(this)) {
      return;
    }
    return _scrollIntoView.apply(this, arguments);
  };

  // Override scrollTo
  window.scrollTo = function () {
    if (blocking()) {
      return;
    }
    return _scrollTo.apply(window, arguments);
  };

  // Override focus (prevent focus-triggered scroll)
  HTMLElement.prototype.focus = function (options) {
    if (blocking()) {
      try {
        return _focus.call(this, { preventScroll: true });
      } catch (e) {
        // Fallback for browsers that do not support preventScroll
        return _focus.call(this);
      }
    }
    return _focus.call(this, options);
  };

  // Arm the blocker when a variant is about to change
  function armBlocker() {
    // Block for a short window so theme updates can run without jumping
    blockAutoScrollUntil = Date.now() + 800;
  }

  // Listen to variant changes inside variant-selects
  document.addEventListener(
    "change",
    function (e) {
      const inVariantSelects = e.target && e.target.closest && e.target.closest("variant-selects");
      if (!inVariantSelects) return;

      // radios, selects, any change inside variant-selects
      armBlocker();
    },
    true
  );

  // Some themes trigger scroll on click before the change event
  document.addEventListener(
    "click",
    function (e) {
      const label = e.target && e.target.closest && e.target.closest("variant-selects label");
      if (label) armBlocker();
    },
    true
  );
})();
